import styled, { css } from 'styled-components';
import { Box, Text, Absolute } from '@rsos/components/capstone/base';

interface ItemCategoryNameProps {
  sideBarOpen: boolean;
  $hideWhenCollapsed?: boolean;
}

interface ItemStateProps {
  isActive?: boolean;
  titleWrap?: boolean;
}

// `$hideWhenCollapsed` hides the label but keeps its height so items below
// don't shift up when collapsed.
export const ItemCategoryName = styled(Text).attrs<ItemCategoryNameProps>(
  ({ sideBarOpen }) => ({
    p: sideBarOpen ? '20px 0 15px 20px' : '20px 5px 15px 5px',
    size: 'xsmall',
    textAlign: sideBarOpen ? 'inherit' : 'center',
    color: 'secondaryText',
    noWrap: true,
  }),
)<ItemCategoryNameProps>`
  ${({ sideBarOpen, $hideWhenCollapsed }) =>
    $hideWhenCollapsed &&
    !sideBarOpen &&
    css`
      visibility: hidden;
      overflow: hidden;
    `}
`;

export const ItemIconWrapper = styled(Box).attrs<ItemStateProps>(
  ({ isActive }) => ({
    align: 'center',
    justify: 'center',
    color: isActive ? 'foreground' : 'primaryBaseC2',
  }),
)<ItemStateProps>`
  min-height: 35px;
`;

export const ItemTitle = styled(Text).attrs<ItemStateProps>(
  ({ titleWrap, isActive }) => ({
    size: 'normal',
    noWrap: !titleWrap,
    color: isActive ? 'foreground' : 'primaryBaseC2',
  }),
)<ItemStateProps>`
  display: flex;
  align-items: center;
`;

export const Circle = styled(Absolute)`
  right: 5px;
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) => `1px solid ${theme.colors.primaryBase}`};
  content: '';
  border-radius: 50%;
`;
